import { useContext, useState } from "react";
import logo from "./logo-eshopex.png" 
import {GetSinToken } from "../Rutas/ApiRest";
import { cuentaCliente } from "../Rutas/Servicios";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { Loading, Modelos } from "./Modelos";

function RecuperarContrasena()
{
    const [Email,SetEmail]=useState("");
    const {SetMensajeEmergente,SetLoading}=useContext(MensajeContActualizacion)

   const enviar=()=>
    {
        if(Email!="")
            {
                const datos=GetSinToken(cuentaCliente.RecuperarContrasena.replace("@email",Email),"application/json")
                datos?.then(resultado=>{SetMensajeEmergente(resultado);SetLoading(false)})
            }
    }



    return (<>
    <div className="container">
    <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
            <div className="d-flex justify-content-center py-4"> <a className="logo d-flex align-items-center w-auto img-fluid" href="https://eshopex.cl"> <img src={logo} alt=""></img></a> </div>
            

            <div className="card mb-3">
              <div className="card-body">
                <div className="pt-4 pb-2">
                  <h5 className="text-center pb-0 fs-4">Recuperar contraseña</h5>
                </div>
                <div className="row g-3 needs-validation" >
                  <div className="col-12">Email
                    <div className="input-group has-validation">
                    <input name="User" type="text"  id="Email" className="form-control" placeholder="E-mail" onChange={(e)=>SetEmail(e.target.value)}></input>
                      <div className="invalid-feedback">Ingresa tu Email</div>
                    </div>
                  </div>
                  <div className="col-12">
                    <button className="btn btn-primary w-100" type="submit" style={{color:"#fff",backgroundColor:"#f98824",borderColor:"#f98824"}} onClick={()=>{SetLoading(true);enviar()}}>Enviar Correo</button>
                  </div>
                 

                  <div className="col-12">
                    <p className="small"><a href="../" style={{textDecoration:"none",color:"#f98824"}}>Volver</a></p>
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  </div>
        <Modelos></Modelos>
           <Loading></Loading>
  </>

    )
}

export default RecuperarContrasena;